// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#customSearchBox {
  width: 70%;
  margin-bottom: 15px;
}
body {
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  background: #F1F3F6;
}
body > div.background {
  background: #F1F3F6;
  height: 100%;
}
@media (min-width: 992px) {
  .col-md-3.main-nav {
    width: 21%;
  }
  .col-md-9.main-content {
    width: 79%;
  }
}
.my-magview .navbar-inverse {
  background: #8D66C4;
  color: #fff;
  margin-bottom: 25px;
}
.my-magview .navbar-inverse .navbar-nav.navbar-right > li > a {
  padding: 15px 12px;
  font-size: 14px;
}
.my-magview .navbar-inverse .navbar-brand img {
  height: 40px;
  margin-top: 5px;
}
.my-magview .panel-default > .panel-heading {
  background: #fff;
}
.my-magview a.toggle-collapse {
  cursor: pointer;
  font-size: 14px;
  color: #337ab7;
  font-weight: bold;
}
.panel-collapse.am-collapse {
  animation-duration: 0.3s;
  animation-timing-function: ease;
  animation-fill-mode: backwards;
  overflow: hidden;
}
.panel-collapse.am-collapse.in-remove {
  animation-name: collapse;
  display: block;
}
.panel-collapse.am-collapse.in-add {
  animation-name: expand;
}
.panel-collapse.am-collapse2 {
  transition: 0.3s ease max-height;
  max-height: 100px;
  overflow: hidden;
}
.panel-collapse.am-collapse2.in-remove {
  max-height: 100px;
  display: block;
}
.panel-collapse.am-collapse2.in-add {
  max-height: 0px;
}
@keyframes expand {
  from {
    max-height: 0px;
  }
  to {
    max-height: 100px;
  }
}
@keyframes collapse {
  from {
    max-height: 100px;
  }
  to {
    max-height: 0px;
  }
}
.details-header {
  border: 1px solid #ddd;
  padding: 20px 20px 10px 20px;
  margin-bottom: 25px;
  border-radius: 5px;
  background: #fff;
}
.details-header .form-group {
  margin-bottom: 5px;
}
.details-header .label {
  font-size: 100%;
}
.tab-pane {
  background: #fff;
  padding: 20px;
  border: 1px solid #ddd;
  border-width: 0 1px 1px 1px;
  margin-bottom: 20px;
}
.table > tbody > tr.no-top-border td {
  border-top-width: 0;
}
.main-nav .toggle-collapse span.label {
  min-width: 28px;
  padding: 3px 8px;
  line-height: 15px;
}
.width-label-tab {
  width: 130px;
}
.home-page-background {
  background: #fff;
  margin-top: -80px;
  padding-top: 80px;
  min-height: 100%;
}
.home-page {
  padding-top: 10%;
}
.home-page h1 {
  margin-bottom: 37px;
  font-size: 72px;
  color: #4285F4;
  font-weight: 600;
}
.home-page .buttons-wrapper {
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 27px;
  text-align: center;
}
.home-page .buttons-wrapper label,
.home-page .buttons-wrapper a.btn {
  font-size: 13px;
  padding: 3px 18px;
  border-radius: 4px;
  border-color: #fff;
  background: #F2F2F2;
  box-shadow: none;
  font-weight: bold;
  color: #757575;
  line-height: 27px;
  height: 36px;
}
.home-page .buttons-wrapper label:hover,
.home-page .buttons-wrapper label.active {
  color: #222;
  border: 1px solid #c6c6c6;
  background: #f8f8f8;
}
.home-page .buttons-wrapper input {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none;
}
.home-page .search-wrapper {
  margin-bottom: 35px;
  margin-left: auto;
  margin-right: auto;
  width: 700px;
  max-width: 100%;
  padding-right: 70px;
  position: relative;
}
.home-page .search-wrapper a.btn {
  display: inline-block;
  width: 70px;
  color: #fff;
  border-radius: 0;
  font-weight: bold;
  font-size: 24px;
  padding: 12px 0;
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  background: #4285F4;
  position: absolute;
  right: 0;
}
.home-page .search-wrapper a.btn:focus {
  border: 1px solid #404F67;
}
.home-page .is-selected .select2-container .select2-chosen {
  color: #444;
}
.home-page .connection-info {
  display: block;
  text-align: center;
}
.home-page .connection-info a {
  /*color: #1a0dab;
      cursor: pointer;*/
  font-weight: bold;
}
@media (max-width: 400px) {
  .home-page .buttons-wrapper label {
    padding: 3px 12px;
  }
  .home-page h1 {
    font-size: 60px;
  }
}
.panel-loading .loader .spinner {
  color: red;
}
.modal-backdrop {
  opacity: 0.4;
}
.modal-dialog {
  border-radius: 0;
  background: #fff;
}
.modal-dialog .modal-header {
  border-radius: 0;
  background: #f3f3f4;
  padding: 15px;
  border-bottom: 1px solid #e5e5e5;
}
.modal-dialog .modal-header h4 {
  color: #6a6c6f;
  font-size: 13px;
}
.modal-dialog .modal-body {
  padding: 20px 30px;
}
.modal-dialog .modal-footer {
  padding: 15px;
  text-align: right;
  border-top: 1px solid #e5e5e5;
  background: #f3f3f4;
}
.modal-dialog.dialog-800 .modal-body {
  height: 600px;
  overflow-x: auto;
}
@media (min-width: 768px) {
  .modal-dialog.dialog-800 {
    width: 90%;
    max-width: 1200px;
  }
}
.navbar > .container .navbar-brand {
  margin-left: 0;
}
@media (max-width: 768px) {
  .navbar > .container .navbar-brand {
    margin-left: 15px;
  }
}
.nav-tabs a {
  cursor: pointer;
}
.btn.btn-xs > i {
  font-size: 12px;
}
.inline-edit-link {
  border: 1px dashed #aaa;
  border-width: 0 0 1px 0;
  cursor: pointer;
}
.switch-customer-wrapper {
  width: 230px;
  display: inline-block;
}
.select2-container {
  width: 100%;
  display: inline-block;
  /*abbr.select2-search-choice-close {
    background: white;
    font-family: FontAwesome;
    color: #757575;
    font-size: 40px;
    margin-top: 3px;
    margin-right: 4px;
  }*/
}
.select2-container.select2-dropdown-open a {
  display: none;
}
.select2-container .select2-choice {
  border-color: #ccc;
  background: #fff;
  box-shadow: none;
  border-radius: 4px;
  padding: 4px 12px;
  height: 34px;
}
.select2-container .select2-choice .select2-arrow {
  display: none;
}
.select2-container abbr.select2-search-choice-close:before {
  content: '\\f00d';
}
.select2-drop {
  border: 1px solid #ccc;
  background: transparent;
  box-shadow: none;
  margin-top: -17px;
  overflow: hidden;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.select2-drop .select2-search {
  padding: 0;
}
.select2-drop .select2-search input[type="text"] {
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  border-width: 0 0 1px 0;
  padding: 6px 12px;
}
.select2-drop .select2-results {
  margin: 0;
  padding: 0;
  background: #fff;
  overflow-x: hidden;
  width: 106%;
}
.select2-drop .select2-results li {
  padding-left: 5px;
  background-position: 98%;
}
.select2-big .select2-container .select2-choice {
  font-size: 24px;
  padding: 12px 20px;
  height: 60px;
  line-height: 34px;
}
.select2-big .select2-container abbr.select2-search-choice-close {
  background: white;
  font-family: FontAwesome;
  color: #757575;
  font-size: 40px;
  margin-top: 3px;
  margin-right: 4px;
}
.select2-big.select2-drop {
  margin-top: -11px;
  border-top-right-radius: 0px;
}
.select2-big.select2-drop .select2-search input {
  font-size: 24px;
  padding: 12px 20px;
}
.select2-big.select2-drop .select2-results {
  max-height: 350px;
  width: 103%;
}
.select2-big.select2-drop .select2-results li {
  font-size: 24px;
  padding: 10px 0 7px 13px;
}
.home-page .select2-container {
  width: 100%;
  margin: auto;
}
.home-page .select2-container .select2-choice {
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 0;
  border-top-left-radius: 4px;
  border-top-right-radius: 0;
  font-weight: 300;
  font-family: 'Open Sans', sans-serif;
}
.home-page .select2-container .select2-chosen {
  color: #BDBDBD;
}
.home-page-custom.select2-drop .select2-search input,
.select2-drop .select2-search input {
  font-weight: 300;
  font-family: 'Open Sans', sans-serif;
}
.home-page-custom.select2-drop .select2-results li,
.select2-drop .select2-results li {
  font-weight: 300;
  font-family: 'Open Sans', sans-serif;
}
.modal-top-buttons {
  text-align: right;
  margin-bottom: 15px;
}
.switch-customer-wrapper .select2-container .select2-choice {
  border: none;
  padding: 0;
  height: auto;
  line-height: normal;
}
.switch-customer-wrapper .select2-container .select2-choice .select2-chosen {
  border: 1px dashed #aaa;
  border-width: 0 0 1px 0;
  margin-right: 0;
}
iframe {
  max-width: 100%;
}
.big-rows .row {
  padding: 10px 0 5px 0;
}
.big-rows .row + .row {
  border-top: 1px solid #ddd;
}
.big-rows .row.without-border + .row.without-border {
  border: none;
  border-top: none;
}
.row.success h3 {
  color: #5cb85c;
}
.row.danger h3 {
  color: #d9534f;
}
.row.status-history {
  border-top: none;
}
.row.status-history h2 {
  font-size: 24px;
}
.same-as-table-search {
  width: 212px;
  display: inline-block;
  margin-right: 5px;
}
.same-as-table-search.with-from-label {
  width: 174px;
}
.partial .partial-header {
  display: none;
}
input[type="email"],
input[type="text"],
input[type="number"],
input[type="password"],
input[type="search"],
textarea,
select.form-control,
.btn.btn-default.form-control {
  padding: 6px 12px;
  background: #FFF;
  border: 1px solid #d0d8df;
  border-radius: 2px;
  color: #1e1e1e;
  font-size: 12px;
  line-height: normal;
  outline: medium none;
  transition-duration: 150ms;
  transition-timing-function: ease;
  box-shadow: none;
}
input[type="email"]:hover,
input.dropdown-button[type="email"]:active,
input.dropdown-button.active[type="email"],
input[type="text"]:hover,
input.dropdown-button[type="text"]:active,
input.dropdown-button.active[type="text"],
input[type="number"]:hover,
input.dropdown-button[type="number"]:active,
input.dropdown-button.active[type="number"],
input[type="password"]:hover,
input.dropdown-button[type="password"]:active,
input.dropdown-button.active[type="password"],
input[type="search"]:hover,
input.dropdown-button[type="search"]:active,
input.dropdown-button.active[type="search"],
textarea:hover,
textarea.dropdown-button:active,
textarea.dropdown-button.active {
  border-color: #c2c2c2;
}
input[type="email"]:focus,
input.focus[type="email"],
input[type="text"]:focus,
input.focus[type="text"],
input[type="number"]:focus,
input.focus[type="number"],
input[type="password"]:focus,
input.focus[type="password"],
input[type="search"]:focus,
input.focus[type="search"],
textarea:focus,
textarea.focus {
  background-color: #fff;
  border-color: #1a90dc;
  box-shadow: 0 0 5px rgba(26, 144, 220, 0.3);
}
textarea {
  min-height: 3em;
  resize: vertical;
}
input[type="radio"] {
  margin: 2px 4px 0 0;
}
.btn {
  border-radius: 3px;
}
.btn-primary.btn-outline:hover,
.btn-success.btn-outline:hover,
.btn-info.btn-outline:hover,
.btn-warning.btn-outline:hover,
.btn-danger.btn-outline:hover {
  color: #fff;
}
.btn-primary {
  background-color: #1ab394;
  border-color: #1ab394;
  color: #FFF;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  background-color: #1eceaa;
  border-color: #1eceaa;
  color: #FFF;
}
.btn-primary:active,
.btn-primary.active,
.open .dropdown-toggle.btn-primary {
  background-image: none;
}
.btn-primary.disabled,
.btn-primary.disabled:hover,
.btn-primary.disabled:focus,
.btn-primary.disabled:active,
.btn-primary.disabled.active,
.btn-primary[disabled],
.btn-primary[disabled]:hover,
.btn-primary[disabled]:focus,
.btn-primary[disabled]:active,
.btn-primary.active[disabled],
fieldset[disabled] .btn-primary,
fieldset[disabled] .btn-primary:hover,
fieldset[disabled] .btn-primary:focus,
fieldset[disabled] .btn-primary:active,
fieldset[disabled] .btn-primary.active {
  background-color: #16987e;
  border-color: #16987e;
}
.modal-content {
  border-radius: 5px;
  border: none;
  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);
}
.form-horizontal .control-label.text-left {
  text-align: left;
}
.margin-top-20 {
  margin-top: 20px;
}
.attendance-tracking-page .fixed-filter .dataTables_filter input,
.time-tracking-page .fixed-filter .dataTables_filter input {
  display: none;
}
.attendance-tracking-page div.panel-title button,
.time-tracking-page div.panel-title button {
  display: none;
}
.build-log-header.container.projects-list {
  position: absolute;
  left: 0;
  right: 0;
}
.prefs-page h2 {
  margin-bottom: 30px;
  margin-top: 30px;
  text-align: center;
}
.build-log-header.container.projects-list a {
  margin-top: 70px;
  margin-left: 55px;
}
.prefs-page .nav-tabs li a {
  color: #23527c;
}
.prefs-page .nav-tabs li a:hover {
  border-color: #eee #eee #ddd;
  text-decoration: none;
  background-color: #eee;
}
.prefs-page .nav-tabs li.active a {
  color: #555;
  cursor: default;
  background-color: #fff;
  border: 1px solid #ddd;
  border-bottom-color: transparent;
}
.prefs-page .tab-pane {
  padding-top: 35px;
}
.prefs-page .artifact-link {
  padding-left: 5px;
  cursor: pointer;
}
.prefs-page a.anchor {
  text-decoration: none;
  cursor: default;
}
table.dataTable.no-footer {
  border-bottom: 1px solid #ddd;
}
table.dataTable.no-footer thead {
  background-color: #f4f8fb;
  color: #1a90dc;
  font-weight: 700;
}
table.dataTable.no-footer thead th {
  text-align: left !important;
  border-bottom: none !important;
  font-size: 13px;
}
table.dataTable.no-footer tbody tr td {
  padding-bottom: 9px;
  padding-top: 9px;
  font-size: 13px;
}
table.dataTable.no-footer tbody tr td .label {
  font-size: 10px;
  width: 80px;
  display: inline-block;
  margin: 0;
  padding-top: 0px;
  padding-bottom: 0px;
  line-height: 18px;
}
table.dataTable.no-footer tbody td.actions-col {
  padding-top: 5px;
  padding-bottom: 5px;
}
table.dataTable.no-footer tbody td.actions-col a.btn {
  padding: 2px 8px 2px 8px;
}
table.dataTable.no-footer tbody td.actions-col a.btn .fa {
  font-size: 13px;
}
.dataTables_wrapper .dataTables_filter {
  width: 50%;
}
.dataTables_wrapper .dataTables_filter {
  display: flex;
  width: 45%;
}
.dataTables_wrapper .dataTables_filter label {
  width: 100%;
}
#prefs-header {
  font-size: 30px;
}
`, "",{"version":3,"sources":["webpack://./src/components/magview/styles/magtac.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,mBAAmB;AACrB;AACA;EACE,wEAAwE;EACxE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,YAAY;AACd;AACA;EACE;IACE,UAAU;EACZ;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,wBAAwB;EACxB,+BAA+B;EAC/B,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,cAAc;AAChB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,eAAe;AACjB;AACA;EACE;IACE,eAAe;EACjB;EACA;IACE,iBAAiB;EACnB;AACF;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,mBAAmB;EACnB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,YAAY;AACd;AACA;;EAEE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;AACtB;AACA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;EACf,4BAA4B;EAC5B,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;AACb;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE;uBACqB;EACrB,iBAAiB;AACnB;AACA;EACE;IACE,iBAAiB;EACnB;EACA;IACE,eAAe;EACjB;AACF;AACA;EACE,UAAU;AACZ;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,gCAAgC;AAClC;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,6BAA6B;EAC7B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;AACA;EACE,cAAc;AAChB;AACA;EACE;IACE,iBAAiB;EACnB;AACF;AACA;EACE,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,WAAW;EACX,qBAAqB;EACrB;;;;;;;IAOE;AACJ;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;AAClB;AACA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,UAAU;AACZ;AACA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,uBAAuB;EACvB,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,eAAe;EACf,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,WAAW;AACb;AACA;EACE,eAAe;EACf,wBAAwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,2BAA2B;EAC3B,0BAA0B;EAC1B,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,cAAc;AAChB;AACA;;EAEE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;;EAEE,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,UAAU;EACV,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;AACnB;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;AACf;AACA;;;;;;;;EAQE,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,gCAAgC;EAChC,gBAAgB;AAClB;AACA;;;;;;;;;;;;;;;;;;EAkBE,qBAAqB;AACvB;AACA;;;;;;;;;;;;EAYE,sBAAsB;EACtB,qBAAqB;EACrB,2CAA2C;AAC7C;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kBAAkB;AACpB;AACA;;;;;EAKE,WAAW;AACb;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;;;EAKE,yBAAyB;EACzB,qBAAqB;EACrB,WAAW;AACb;AACA;;;EAGE,sBAAsB;AACxB;AACA;;;;;;;;;;;;;;;EAeE,yBAAyB;EACzB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,oEAAoE;AACtE;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,aAAa;AACf;AACA;;EAEE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;AAClC;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,eAAe;AACjB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,WAAW;EACX,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;AACZ;AACA;EACE,aAAa;EACb,UAAU;AACZ;AACA;EACE,WAAW;AACb;AACA;EACE,eAAe;AACjB","sourcesContent":["#customSearchBox {\n  width: 70%;\n  margin-bottom: 15px;\n}\nbody {\n  font-family: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  background: #F1F3F6;\n}\nbody > div.background {\n  background: #F1F3F6;\n  height: 100%;\n}\n@media (min-width: 992px) {\n  .col-md-3.main-nav {\n    width: 21%;\n  }\n  .col-md-9.main-content {\n    width: 79%;\n  }\n}\n.my-magview .navbar-inverse {\n  background: #8D66C4;\n  color: #fff;\n  margin-bottom: 25px;\n}\n.my-magview .navbar-inverse .navbar-nav.navbar-right > li > a {\n  padding: 15px 12px;\n  font-size: 14px;\n}\n.my-magview .navbar-inverse .navbar-brand img {\n  height: 40px;\n  margin-top: 5px;\n}\n.my-magview .panel-default > .panel-heading {\n  background: #fff;\n}\n.my-magview a.toggle-collapse {\n  cursor: pointer;\n  font-size: 14px;\n  color: #337ab7;\n  font-weight: bold;\n}\n.panel-collapse.am-collapse {\n  animation-duration: 0.3s;\n  animation-timing-function: ease;\n  animation-fill-mode: backwards;\n  overflow: hidden;\n}\n.panel-collapse.am-collapse.in-remove {\n  animation-name: collapse;\n  display: block;\n}\n.panel-collapse.am-collapse.in-add {\n  animation-name: expand;\n}\n.panel-collapse.am-collapse2 {\n  transition: 0.3s ease max-height;\n  max-height: 100px;\n  overflow: hidden;\n}\n.panel-collapse.am-collapse2.in-remove {\n  max-height: 100px;\n  display: block;\n}\n.panel-collapse.am-collapse2.in-add {\n  max-height: 0px;\n}\n@keyframes expand {\n  from {\n    max-height: 0px;\n  }\n  to {\n    max-height: 100px;\n  }\n}\n@keyframes collapse {\n  from {\n    max-height: 100px;\n  }\n  to {\n    max-height: 0px;\n  }\n}\n.details-header {\n  border: 1px solid #ddd;\n  padding: 20px 20px 10px 20px;\n  margin-bottom: 25px;\n  border-radius: 5px;\n  background: #fff;\n}\n.details-header .form-group {\n  margin-bottom: 5px;\n}\n.details-header .label {\n  font-size: 100%;\n}\n.tab-pane {\n  background: #fff;\n  padding: 20px;\n  border: 1px solid #ddd;\n  border-width: 0 1px 1px 1px;\n  margin-bottom: 20px;\n}\n.table > tbody > tr.no-top-border td {\n  border-top-width: 0;\n}\n.main-nav .toggle-collapse span.label {\n  min-width: 28px;\n  padding: 3px 8px;\n  line-height: 15px;\n}\n.width-label-tab {\n  width: 130px;\n}\n.home-page-background {\n  background: #fff;\n  margin-top: -80px;\n  padding-top: 80px;\n  min-height: 100%;\n}\n.home-page {\n  padding-top: 10%;\n}\n.home-page h1 {\n  margin-bottom: 37px;\n  font-size: 72px;\n  color: #4285F4;\n  font-weight: 600;\n}\n.home-page .buttons-wrapper {\n  margin-left: auto;\n  margin-right: auto;\n  margin-bottom: 27px;\n  text-align: center;\n}\n.home-page .buttons-wrapper label,\n.home-page .buttons-wrapper a.btn {\n  font-size: 13px;\n  padding: 3px 18px;\n  border-radius: 4px;\n  border-color: #fff;\n  background: #F2F2F2;\n  box-shadow: none;\n  font-weight: bold;\n  color: #757575;\n  line-height: 27px;\n  height: 36px;\n}\n.home-page .buttons-wrapper label:hover,\n.home-page .buttons-wrapper label.active {\n  color: #222;\n  border: 1px solid #c6c6c6;\n  background: #f8f8f8;\n}\n.home-page .buttons-wrapper input {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n}\n.home-page .search-wrapper {\n  margin-bottom: 35px;\n  margin-left: auto;\n  margin-right: auto;\n  width: 700px;\n  max-width: 100%;\n  padding-right: 70px;\n  position: relative;\n}\n.home-page .search-wrapper a.btn {\n  display: inline-block;\n  width: 70px;\n  color: #fff;\n  border-radius: 0;\n  font-weight: bold;\n  font-size: 24px;\n  padding: 12px 0;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  background: #4285F4;\n  position: absolute;\n  right: 0;\n}\n.home-page .search-wrapper a.btn:focus {\n  border: 1px solid #404F67;\n}\n.home-page .is-selected .select2-container .select2-chosen {\n  color: #444;\n}\n.home-page .connection-info {\n  display: block;\n  text-align: center;\n}\n.home-page .connection-info a {\n  /*color: #1a0dab;\n      cursor: pointer;*/\n  font-weight: bold;\n}\n@media (max-width: 400px) {\n  .home-page .buttons-wrapper label {\n    padding: 3px 12px;\n  }\n  .home-page h1 {\n    font-size: 60px;\n  }\n}\n.panel-loading .loader .spinner {\n  color: red;\n}\n.modal-backdrop {\n  opacity: 0.4;\n}\n.modal-dialog {\n  border-radius: 0;\n  background: #fff;\n}\n.modal-dialog .modal-header {\n  border-radius: 0;\n  background: #f3f3f4;\n  padding: 15px;\n  border-bottom: 1px solid #e5e5e5;\n}\n.modal-dialog .modal-header h4 {\n  color: #6a6c6f;\n  font-size: 13px;\n}\n.modal-dialog .modal-body {\n  padding: 20px 30px;\n}\n.modal-dialog .modal-footer {\n  padding: 15px;\n  text-align: right;\n  border-top: 1px solid #e5e5e5;\n  background: #f3f3f4;\n}\n.modal-dialog.dialog-800 .modal-body {\n  height: 600px;\n  overflow-x: auto;\n}\n@media (min-width: 768px) {\n  .modal-dialog.dialog-800 {\n    width: 90%;\n    max-width: 1200px;\n  }\n}\n.navbar > .container .navbar-brand {\n  margin-left: 0;\n}\n@media (max-width: 768px) {\n  .navbar > .container .navbar-brand {\n    margin-left: 15px;\n  }\n}\n.nav-tabs a {\n  cursor: pointer;\n}\n.btn.btn-xs > i {\n  font-size: 12px;\n}\n.inline-edit-link {\n  border: 1px dashed #aaa;\n  border-width: 0 0 1px 0;\n  cursor: pointer;\n}\n.switch-customer-wrapper {\n  width: 230px;\n  display: inline-block;\n}\n.select2-container {\n  width: 100%;\n  display: inline-block;\n  /*abbr.select2-search-choice-close {\n    background: white;\n    font-family: FontAwesome;\n    color: #757575;\n    font-size: 40px;\n    margin-top: 3px;\n    margin-right: 4px;\n  }*/\n}\n.select2-container.select2-dropdown-open a {\n  display: none;\n}\n.select2-container .select2-choice {\n  border-color: #ccc;\n  background: #fff;\n  box-shadow: none;\n  border-radius: 4px;\n  padding: 4px 12px;\n  height: 34px;\n}\n.select2-container .select2-choice .select2-arrow {\n  display: none;\n}\n.select2-container abbr.select2-search-choice-close:before {\n  content: '\\f00d';\n}\n.select2-drop {\n  border: 1px solid #ccc;\n  background: transparent;\n  box-shadow: none;\n  margin-top: -17px;\n  overflow: hidden;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.select2-drop .select2-search {\n  padding: 0;\n}\n.select2-drop .select2-search input[type=\"text\"] {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n  border-width: 0 0 1px 0;\n  padding: 6px 12px;\n}\n.select2-drop .select2-results {\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  overflow-x: hidden;\n  width: 106%;\n}\n.select2-drop .select2-results li {\n  padding-left: 5px;\n  background-position: 98%;\n}\n.select2-big .select2-container .select2-choice {\n  font-size: 24px;\n  padding: 12px 20px;\n  height: 60px;\n  line-height: 34px;\n}\n.select2-big .select2-container abbr.select2-search-choice-close {\n  background: white;\n  font-family: FontAwesome;\n  color: #757575;\n  font-size: 40px;\n  margin-top: 3px;\n  margin-right: 4px;\n}\n.select2-big.select2-drop {\n  margin-top: -11px;\n  border-top-right-radius: 0px;\n}\n.select2-big.select2-drop .select2-search input {\n  font-size: 24px;\n  padding: 12px 20px;\n}\n.select2-big.select2-drop .select2-results {\n  max-height: 350px;\n  width: 103%;\n}\n.select2-big.select2-drop .select2-results li {\n  font-size: 24px;\n  padding: 10px 0 7px 13px;\n}\n.home-page .select2-container {\n  width: 100%;\n  margin: auto;\n}\n.home-page .select2-container .select2-choice {\n  border-bottom-left-radius: 4px;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 4px;\n  border-top-right-radius: 0;\n  font-weight: 300;\n  font-family: 'Open Sans', sans-serif;\n}\n.home-page .select2-container .select2-chosen {\n  color: #BDBDBD;\n}\n.home-page-custom.select2-drop .select2-search input,\n.select2-drop .select2-search input {\n  font-weight: 300;\n  font-family: 'Open Sans', sans-serif;\n}\n.home-page-custom.select2-drop .select2-results li,\n.select2-drop .select2-results li {\n  font-weight: 300;\n  font-family: 'Open Sans', sans-serif;\n}\n.modal-top-buttons {\n  text-align: right;\n  margin-bottom: 15px;\n}\n.switch-customer-wrapper .select2-container .select2-choice {\n  border: none;\n  padding: 0;\n  height: auto;\n  line-height: normal;\n}\n.switch-customer-wrapper .select2-container .select2-choice .select2-chosen {\n  border: 1px dashed #aaa;\n  border-width: 0 0 1px 0;\n  margin-right: 0;\n}\niframe {\n  max-width: 100%;\n}\n.big-rows .row {\n  padding: 10px 0 5px 0;\n}\n.big-rows .row + .row {\n  border-top: 1px solid #ddd;\n}\n.big-rows .row.without-border + .row.without-border {\n  border: none;\n  border-top: none;\n}\n.row.success h3 {\n  color: #5cb85c;\n}\n.row.danger h3 {\n  color: #d9534f;\n}\n.row.status-history {\n  border-top: none;\n}\n.row.status-history h2 {\n  font-size: 24px;\n}\n.same-as-table-search {\n  width: 212px;\n  display: inline-block;\n  margin-right: 5px;\n}\n.same-as-table-search.with-from-label {\n  width: 174px;\n}\n.partial .partial-header {\n  display: none;\n}\ninput[type=\"email\"],\ninput[type=\"text\"],\ninput[type=\"number\"],\ninput[type=\"password\"],\ninput[type=\"search\"],\ntextarea,\nselect.form-control,\n.btn.btn-default.form-control {\n  padding: 6px 12px;\n  background: #FFF;\n  border: 1px solid #d0d8df;\n  border-radius: 2px;\n  color: #1e1e1e;\n  font-size: 12px;\n  line-height: normal;\n  outline: medium none;\n  transition-duration: 150ms;\n  transition-timing-function: ease;\n  box-shadow: none;\n}\ninput[type=\"email\"]:hover,\ninput.dropdown-button[type=\"email\"]:active,\ninput.dropdown-button.active[type=\"email\"],\ninput[type=\"text\"]:hover,\ninput.dropdown-button[type=\"text\"]:active,\ninput.dropdown-button.active[type=\"text\"],\ninput[type=\"number\"]:hover,\ninput.dropdown-button[type=\"number\"]:active,\ninput.dropdown-button.active[type=\"number\"],\ninput[type=\"password\"]:hover,\ninput.dropdown-button[type=\"password\"]:active,\ninput.dropdown-button.active[type=\"password\"],\ninput[type=\"search\"]:hover,\ninput.dropdown-button[type=\"search\"]:active,\ninput.dropdown-button.active[type=\"search\"],\ntextarea:hover,\ntextarea.dropdown-button:active,\ntextarea.dropdown-button.active {\n  border-color: #c2c2c2;\n}\ninput[type=\"email\"]:focus,\ninput.focus[type=\"email\"],\ninput[type=\"text\"]:focus,\ninput.focus[type=\"text\"],\ninput[type=\"number\"]:focus,\ninput.focus[type=\"number\"],\ninput[type=\"password\"]:focus,\ninput.focus[type=\"password\"],\ninput[type=\"search\"]:focus,\ninput.focus[type=\"search\"],\ntextarea:focus,\ntextarea.focus {\n  background-color: #fff;\n  border-color: #1a90dc;\n  box-shadow: 0 0 5px rgba(26, 144, 220, 0.3);\n}\ntextarea {\n  min-height: 3em;\n  resize: vertical;\n}\ninput[type=\"radio\"] {\n  margin: 2px 4px 0 0;\n}\n.btn {\n  border-radius: 3px;\n}\n.btn-primary.btn-outline:hover,\n.btn-success.btn-outline:hover,\n.btn-info.btn-outline:hover,\n.btn-warning.btn-outline:hover,\n.btn-danger.btn-outline:hover {\n  color: #fff;\n}\n.btn-primary {\n  background-color: #1ab394;\n  border-color: #1ab394;\n  color: #FFF;\n}\n.btn-primary:hover,\n.btn-primary:focus,\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  background-color: #1eceaa;\n  border-color: #1eceaa;\n  color: #FFF;\n}\n.btn-primary:active,\n.btn-primary.active,\n.open .dropdown-toggle.btn-primary {\n  background-image: none;\n}\n.btn-primary.disabled,\n.btn-primary.disabled:hover,\n.btn-primary.disabled:focus,\n.btn-primary.disabled:active,\n.btn-primary.disabled.active,\n.btn-primary[disabled],\n.btn-primary[disabled]:hover,\n.btn-primary[disabled]:focus,\n.btn-primary[disabled]:active,\n.btn-primary.active[disabled],\nfieldset[disabled] .btn-primary,\nfieldset[disabled] .btn-primary:hover,\nfieldset[disabled] .btn-primary:focus,\nfieldset[disabled] .btn-primary:active,\nfieldset[disabled] .btn-primary.active {\n  background-color: #16987e;\n  border-color: #16987e;\n}\n.modal-content {\n  border-radius: 5px;\n  border: none;\n  box-shadow: 0 0 1px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n.form-horizontal .control-label.text-left {\n  text-align: left;\n}\n.margin-top-20 {\n  margin-top: 20px;\n}\n.attendance-tracking-page .fixed-filter .dataTables_filter input,\n.time-tracking-page .fixed-filter .dataTables_filter input {\n  display: none;\n}\n.attendance-tracking-page div.panel-title button,\n.time-tracking-page div.panel-title button {\n  display: none;\n}\n.build-log-header.container.projects-list {\n  position: absolute;\n  left: 0;\n  right: 0;\n}\n.prefs-page h2 {\n  margin-bottom: 30px;\n  margin-top: 30px;\n  text-align: center;\n}\n.build-log-header.container.projects-list a {\n  margin-top: 70px;\n  margin-left: 55px;\n}\n.prefs-page .nav-tabs li a {\n  color: #23527c;\n}\n.prefs-page .nav-tabs li a:hover {\n  border-color: #eee #eee #ddd;\n  text-decoration: none;\n  background-color: #eee;\n}\n.prefs-page .nav-tabs li.active a {\n  color: #555;\n  cursor: default;\n  background-color: #fff;\n  border: 1px solid #ddd;\n  border-bottom-color: transparent;\n}\n.prefs-page .tab-pane {\n  padding-top: 35px;\n}\n.prefs-page .artifact-link {\n  padding-left: 5px;\n  cursor: pointer;\n}\n.prefs-page a.anchor {\n  text-decoration: none;\n  cursor: default;\n}\ntable.dataTable.no-footer {\n  border-bottom: 1px solid #ddd;\n}\ntable.dataTable.no-footer thead {\n  background-color: #f4f8fb;\n  color: #1a90dc;\n  font-weight: 700;\n}\ntable.dataTable.no-footer thead th {\n  text-align: left !important;\n  border-bottom: none !important;\n  font-size: 13px;\n}\ntable.dataTable.no-footer tbody tr td {\n  padding-bottom: 9px;\n  padding-top: 9px;\n  font-size: 13px;\n}\ntable.dataTable.no-footer tbody tr td .label {\n  font-size: 10px;\n  width: 80px;\n  display: inline-block;\n  margin: 0;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  line-height: 18px;\n}\ntable.dataTable.no-footer tbody td.actions-col {\n  padding-top: 5px;\n  padding-bottom: 5px;\n}\ntable.dataTable.no-footer tbody td.actions-col a.btn {\n  padding: 2px 8px 2px 8px;\n}\ntable.dataTable.no-footer tbody td.actions-col a.btn .fa {\n  font-size: 13px;\n}\n.dataTables_wrapper .dataTables_filter {\n  width: 50%;\n}\n.dataTables_wrapper .dataTables_filter {\n  display: flex;\n  width: 45%;\n}\n.dataTables_wrapper .dataTables_filter label {\n  width: 100%;\n}\n#prefs-header {\n  font-size: 30px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
